import { DisplayableImageData } from 'app/interfaces/Image';
import { isAcquisitionImage } from 'app/utils/isAcquisitionImage';

export default function isCompatibleWithPACS(image: {
  origin: string;
  displayableImage: DisplayableImageData;
}) {
  return (
    isAcquisitionImage(image) && image?.displayableImage?.getPixelData() instanceof Uint16Array
  );
}
